import { render, staticRenderFns } from "./sxjsyzhb.vue?vue&type=template&id=47bb60ca&scoped=true&"
import script from "./sxjsyzhb.vue?vue&type=script&lang=js&"
export * from "./sxjsyzhb.vue?vue&type=script&lang=js&"
import style0 from "./sxjsyzhb.vue?vue&type=style&index=0&id=47bb60ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bb60ca",
  null
  
)

export default component.exports